import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
  ButtonGroup,
  Button,
  Card,
  CardTitle,
  CardBody,
  Form,
  Col,
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import Alert from "react-s-alert";
import { api } from "../helpers";

export default class Impersonate extends Component {
  static displayName = Impersonate.name;
  constructor(props) {
    super(props);
    this.state = {
      email:
        props.location.state && props.location.state.email
          ? props.location.state.email
          : '',
    };
    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);

  }
  onChange(e) {
    this.setState({ email: e.target.value });
  }

  onSave(event) {
    event.preventDefault();
    if (this.state.email.trim() === '') {
      Alert.error(
        `Either enter a username to impersonate or choose to cancel.`
      );
    }
    api.post('impersonate', { Email: this.state.email }).then(response => {
      if (!response.data.result) {
        Alert.error(
          `There was an error trying to impersonate: ${response.data.message}`
        );
      } else {
        this.props.setImpersonation(response.data.result, response.data.result.token);
        const message = 'You are now impersonating ' + response.data.result.firstName + ' ' + response.data.result.lastName + ' and will be redirected momentarily!'
        Alert.success(message);
        setTimeout(function () {
          window.location.pathname = '/'
        }, 100, this);
      }
    }).catch(api.catchHandler);
  }

  render() {
    if (this.state.redirectToHome) {
      return (<Redirect from="/" to={{ pathname: "/", push: true }} />);
    }

    return (
      <Card className="m-2">
        <CardTitle className="mt-3 ml-3 mr-2 mb-0">
          <h3>Impersonate</h3>
        </CardTitle>
        <CardBody className="mb-0 pt-1">
          <Row className="mt-3">
            <Col sm={{ size: 10, offset: 1 }}>
              <Form>
                <Row className="mb-2">
                  <Col sm="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText style={{ width: '160px' }}>User's Email</InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" onChange={this.onChange} value={this.state.email} maxLength="50" />
                    </InputGroup>
                  </Col>
                  <Col className="text-right">
                    <ButtonGroup>
                      <Button className="cbdmdPrimary" onClick={this.onSave}>OK</Button>
                      <Button color="secondary" tag={Link} to="/">Cancel</Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Impersonate.js